import { IRowData } from '../components/Results/interfaces';

import { fetchReverseGeocode, MapboxResult } from './mapbox';

const reverseGeocoderCache = new Map<string, MapboxResult>();

export async function reverseGeocoder(longitude: number, latitude: number) {
  const cacheKey = `${longitude},${latitude}`;
  if (reverseGeocoderCache.has(cacheKey)) {
    return reverseGeocoderCache.get(cacheKey);
  }

  try {
    const response = await fetchReverseGeocode(longitude, latitude);
    const data = await response.json();
    reverseGeocoderCache.set(cacheKey, data);
    return data;
  } catch (error) {
    console.error('Reverse geocoding error:', error);
    return null;
  }
}

function getCityName(location?: MapboxResult) {
  const feature = location?.features?.[0];
  if (!feature) return undefined;

  if (feature.properties.context.country.country_code === 'US') {
    return feature.properties.context.place?.name;
  }

  return (
    feature.properties.context.region?.name ||
    feature.properties.context.place?.name
  );
}

export async function getMissingCityCountryFromLatLng(item: IRowData) {
  if (item.city && item.country) {
    return item;
  }

  const { coordinates } = item;
  const [latitude, longitude] = coordinates;

  const results = await reverseGeocoder(longitude, latitude);

  const city = getCityName(results || undefined);

  item.city = city || '';
  item.country =
    results?.features?.[0]?.properties?.context?.country?.name || '';

  return item;
}
